import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Moon, Compass } from "lucide-react";
import { api, inr } from "@/lib/api";

export function PackageCard({ p, testid }) {
  return (
    <Link to={`/packages/${p.slug}`} data-testid={testid}
      className="group grid md:grid-cols-5 bg-white ring-1 ring-black/5 rounded-2xl overflow-hidden">
      <div className="md:col-span-2 h-56 md:h-full overflow-hidden">
        <img src={p.image_url} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transform duration-500"/>
      </div>
      <div className="md:col-span-3 p-6 flex flex-col">
        <div className="jt-eyebrow mb-2">Stay + safari</div>
        <h3 className="font-serif text-2xl text-[#1C2421]">{p.name}</h3>
        <p className="text-sm text-[#5C6B63] mt-2">{p.short_description}</p>
        <div className="flex flex-wrap gap-4 text-xs text-[#5C6B63] mt-4">
          <span className="flex items-center gap-1"><Moon size={13}/>{p.nights} nights · {p.hotel_name}</span>
          <span className="flex items-center gap-1"><Compass size={13}/>{p.safari_name}</span>
        </div>
        <div className="mt-auto pt-5 flex items-center justify-between">
          <span><span className="font-serif text-2xl text-[#1E3A2B]">{inr(p.price)}</span> <span className="text-xs text-[#5C6B63]">per package, 1 room</span></span>
          <span className="text-[#C86D51] text-sm">See package →</span>
        </div>
      </div>
    </Link>
  );
}

export default function Packages() {
  const [pkgs, setPkgs] = useState([]);
  useEffect(() => { api.get("/packages").then((r) => setPkgs(r.data)); }, []);
  return (
    <div className="jt-container py-16">
      <div className="jt-eyebrow mb-3">Tour packages</div>
      <h1 className="font-serif text-4xl md:text-5xl text-[#1E3A2B] mb-3">Stay + safari, one price</h1>
      <p className="text-[#5C6B63] max-w-2xl mb-10">Room, meals, a private leopard safari and permits — booked together in a single checkout.</p>
      <div className="grid gap-6 lg:grid-cols-2">
        {pkgs.map((p) => <PackageCard key={p.id} p={p} testid={`package-card-${p.slug}`}/>)}
      </div>
    </div>
  );
}
